import { Link } from "react-router-dom";

export default function ProductItem({data}){
    return(
        <div className="col mb-5">
            <div className="card h-100">
                {data.sale && <div className="badge bg-dark text-white position-absolute" style={{top: "0.5rem", right: "0.5rem"}}>حراج</div>}
                <img className="card-img-top" src={data.images} alt="..." />
                <div className="card-body p-4">
                    <div className="text-center">
                        <h5 className="fw-bolder">{data.name}</h5>
                        {data.review && <div className="d-flex justify-content-center small text-warning mb-2">
                            {Array(data.review).fill(0).map((_, i) => <div className="ti-star" key={i}></div>)}
                        </div>}
                        {data.sale && <span className="text-muted text-decoration-line-through">{data.sale}</span>}
                        {data.price}
                    </div>
                </div>
                <div className="card-footer p-4 pt-0 border-top-0 bg-transparent">
                    <div className="text-center"><Link to={`/product/${data.id}`} className="btn btn-outline-dark mt-auto" href="#!">مشاهده</Link></div>
                </div>
            </div>
        </div>
    )
}